export default __webpack_public_path__ + "static/media/default-irrigation.fccbadde.jpg";